import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchDrink(props) {
    const { categories, setResult, setIsSearching } = props;

    const { t } = useTranslation();

    function search(e) {
        if (typeof e.target.value === "string" && e.target.value !== "") {
            const target = e.target.value.toLowerCase();
            let result = [];

            categories.forEach(category => {
                const drinks = category.drinks.filter(drink => drink.name.includes(target));
                if (drinks.length > 0) {
                    result.push({ drinks, name: category.name });
                }
            });

            setResult(result);
            setIsSearching(true);
        } else {
            setResult(categories);
            setIsSearching(false);
        }
    };

    return (
        <div className='flex justify-start items-center gap-2 w-full my-2 p-2 rounded-lg border-2 bg-gray-100'>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="#535862" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <input
                className='text-gray-700 bg-gray-100 w-full outline-none'
                placeholder={t("searchdrink.input")}
                onChange={search} />
        </div>
    );
}
